import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { getReferralList } from 'api/hs/TransactionAndLists/ReferralList';
import HSTableAndPaginationAndTableContextProvider from 'Common/Table/HSTable/HSTableAndPaginationAndTableContextProvider';

import { HSTableProps } from '../../Common/Table/HSTable/hs-table.props';
import { CELL } from './COLUMS';
import ListTable from './ListTable';
import Toolbar from './Toolbar';

export default function Examination() {
  const history = useHistory();
  const fetchReferralList = useCallback<HSTableProps<any>['fetcher']>((page, size, sorting, extra) => {
    return getReferralList(
      page,
      size,
      sorting === false ? 'referralDate-DESC' : `${sorting.id as string}-${sorting.direction.toUpperCase()}`
    );
  }, []);
  return (
    <HSTableAndPaginationAndTableContextProvider
      fetcher={fetchReferralList}
      RowProps={{ className: 'cursor-pointer' }}
      columns={CELL}
      onRowClick={row => history.push(`/transactions/employee/${row.employeeId}/referral`)}>
      <Toolbar />
      <ListTable />
    </HSTableAndPaginationAndTableContextProvider>
  );
}
